import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { facebookLook, type FacebookLook } from './facebook-post-preview';
import { GBP_NETWORK, type GbpLook } from './gbp-post-preview';
import { instagramLook, type InstagramLook } from './instagram-post-preview';
import { linkedinLook, type LinkedinLook } from './linkedin-post-preview';
import { pinterestLook, type PinterestLook } from './pinterest-post-preview';
import { tiktokLook, type TiktokLook } from './tiktok-post-preview';
import { xLook, type XLook } from './x-post-preview';
import { youtubeLook, type YoutubeLook } from './youtube-post-preview';

export type SocialPostLook = FacebookLook | InstagramLook | LinkedinLook | XLook | TiktokLook | YoutubeLook | PinterestLook | GbpLook;

export function socialPostLook(card: SocialPostPreviewCardMetadata): SocialPostLook | undefined {
  switch (card.network) {
    case 'facebook':
      return facebookLook(card);
    case 'instagram':
      return instagramLook(card);
    case 'linkedin':
      return linkedinLook(card);
    case 'x':
    case 'twitter':
      return xLook(card);
    case 'tiktok':
      return tiktokLook(card);
    case 'youtube':
      return youtubeLook(card);
    case 'pinterest':
      return pinterestLook(card);
    case GBP_NETWORK:
      return 'gbp';
    default:
      return undefined;
  }
}
